document.addEventListener("DOMContentLoaded", function() {
    const addToCartButtons = document.querySelectorAll('.cart__button');

    addToCartButtons.forEach(button => {
        button.addEventListener('click', function() {
            const variantId = this.getAttribute('data-id');
            const quantityInput = this.closest('tr').querySelector('.cart__product-qty');
            const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: quantity
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
                updateCartCount();
                location.reload();
               
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        });
    });

    function updateCartCount() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                document.querySelector('.cart-count').textContent = data.item_count;
            });
    }
});